import { Nil } from "./types";

export const convert = {
  toInt(value: string): number {
    const result = this.tryToInt(value);
    if (result == null) {
      throw new Error("Invalid Number Format");
    }
    return result;
  },

  tryToInt(value: string | Nil): number | null {
    if (value == null) return null;
    value = value.trim();
    const isNumber = /^-?[0-9]+$/.test(value);
    const result = parseInt(value, 10);
    if (!isNumber || Number.isNaN(result)) {
      return null;
    }
    return result;
  },

  toFloat(value: string): number {
    const result = this.tryToFloat(value);
    if (result == null) {
      throw new Error("Invalid Number Format");
    }
    return result;
  },

  tryToFloat(value: string | Nil): number | null {
    if (value == null) return null;
    value = value.trim();
    const isNumber = /^-?\.?[0-9]+\.?[0-9]*$/.test(value);
    const result = parseFloat(value);
    if (!isNumber || Number.isNaN(result)) {
      return null;
    }
    return result;
  },
};
